
























































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';

@Component
export default class GroupView extends Vue {
  public items: Common.PartneredTenant[] = new Array();
  public params: Common.PartneredTenantQuery = new Common.PartneredTenantQuery();
  public exportQuery = new Common.ExportQuery('顧問先テナント', this.params);

  public sortOptions: any = [
    { value: 'tenantid', text: 'テナントID' },
    { value: 'tenantname', text: 'テナント名称' },
  ];

  //テナントに遷移
  public onClick(tenantId:string){        
    if (this.$api.enviromentFlag == Common.enviromentFlags.production) window.open(String.format("https://{0}.s-flow.net",tenantId), '_blank');       
    else window.open(String.format("https://{0}.code-x.co.jp",tenantId), '_blank');                     
  }

  public created(){
  }  
}
